export enum ISortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export interface ISorting {
  onSetSort: (field: string, direction: ISortDirection) => void
  sortField?: string
  sortDirection?: ISortDirection
}
